import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import KnowledgePanel from '../knowledge-panel/knowledge-panel';
import CommunityPanel from '../community-panel/community-panel';
import {CompetencyModel} from '@/models/proficiency/competency';
import { competencyStatus } from '@/helpers/competency';
import { searchAPI } from '@/providers/apis/search/search';
import moment from 'moment';
import MindsetsPanel from '../mindsets-panel/mindsets-panel';
import { DomainModel } from '@/models/proficiency/domain';
import { SubjectModel } from '@/models/taxonomy/subject';
import { Topic } from '@/models/proficiency/domain-topic/topic';
import RouteGeneratePanel from '../route-generate-panel/route-generate-panel';
import { RGDomainModel } from '@/models/proficiency/route-generator';
import { appConfigService } from '@/providers/services/app/app-config';
import PortfolioPanel from '../portfolio-panel/portfolio-panel';

@Component({
  name: 'competency-info-panel',
  components: {
    'google-material-icon': GoogleMaterialIcon,
    MindsetsPanel,
    KnowledgePanel,
    CommunityPanel,
    'rg-panel': RouteGeneratePanel,
    'portfolio-panel': PortfolioPanel,
  },
})

export default class CompetencyInfoPanel extends Vue {

  @Prop()
  public domain!: DomainModel;

  @Prop()
  public subject!: SubjectModel;

  @Prop()
  public topic!: Topic;

  @Prop()
  private competency!: CompetencyModel;

  @Prop()
  private rgDomains!: RGDomainModel[];

  @Prop()
  private isShowcasePage!: boolean;

  private activeTab: object = {
    title: 'Knowledge',
    component: KnowledgePanel,
  };

  @Prop()
  private userId!: string;

  private get isSuperUser() {
    return this.$access.hasPermission('all', 'all');
  }

  private get isDemoTenant() {
    return appConfigService.isDemoTenant() || this.$access.hasProficiencyRoute;
  }

  private tabItems = [
    {
      title: 'Knowledge',
      component: KnowledgePanel,
    },
    {
      title: this.isShowcasePage ? 'Journey' : 'Mindset',
      component: this.isShowcasePage ? 'portfolio-panel' : MindsetsPanel,
    },
    {
      title: 'Citizenship',
      component: CommunityPanel,
    },
  ];

  @Prop()
  private month!: string;

  @Prop()
  private year!: string;

  private learningMapData?: any = [];

  @Prop()
  private isShowRouteGenerate!: boolean;

  @Watch('competency')
  private onChangeCompetency() {
    this.loadLearningMapContents();
  }

  private created() {
    this.loadLearningMapContents();
  }


  private competencyLevel() {
    return this.competency.competencyStatus ? competencyStatus(this.competency.competencyStatus) : '';
  }

  private onSelectRoutLink() {
    this.$emit('onShowRouteLine', true);
  }

  private onCloseRoute() {
    this.$emit('onShowRouteLine', false);
  }

  private loadLearningMapContents() {
    const component = this;
    const competencyCode = this.competency.competencyCode;
    searchAPI.fetchLearningMapContents(competencyCode).then((learningMapData) => {
      component.learningMapData = learningMapData;
    });
  }

}
